import React from 'react'
import createReactClass from 'create-react-class'
import ConnectAnalysisContainer from '../containers/analysis-panel-container'

export default createReactClass({
  render () {
    return (
      <section>
        <ConnectAnalysisContainer {...this.props}/>
      </section>
    )
  },
})



// WEBPACK FOOTER //
// ./src/views/analysis.js